/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { CardGridGroup, CardGridItemProps } from '../survey-scope/CardGrid';
import { roles, Role } from '../../constants/roles';
import { ViewValues } from '../survey-overview-sidebar/viewOptions';
import { CardProps } from '../../types/surveyScope';
import { UserMin, SurveyUserRoles } from '../../constants/users';

export const getRolesCards = ({ handleDrilldown, users, breadcrumbs, isUserDelegated }: CardProps) => {
  const cardGroups: CardGridGroup[] = [];
  const cards: CardGridItemProps[] = [];

  const scopeVisible = [SurveyUserRoles.Stakeholder, SurveyUserRoles.Verifier];
  const surveyVisible = [SurveyUserRoles.Admin, SurveyUserRoles.Stakeholder, SurveyUserRoles.Verifier];

  const isDrilldown = breadcrumbs && breadcrumbs.length > 0;
  const visible = isDrilldown ? scopeVisible : surveyVisible;

  visible.forEach((code: string) => {
    const role: Role = roles[code];
    const filteredUserList: UserMin[] = [];
    users.forEach(user => {
      if (isUserDelegated && isUserDelegated(user._id, code)) {
        filteredUserList.push(user);
      }
    });

    let subtitle = role.subtitle;
    if (!subtitle && role.description) {
      subtitle = role.description.length > 60 ? `${role.description.substr(0, 60)}...` : role.description;
    }

    const buttons = [];
    buttons.push({
      icon: <i className='fas fa-users text-primary' />,
      tooltip: `View ${role.name}s for this scope`,
      onClick: () => handleDrilldown(ViewValues.Users, role.code, role.name)
    });

    cards.push({
      key: `scope-cardgriditem-standards-${code}`,
      title: <><span>{role.name}s</span></>,
      sortTitle: role.name,
      subtitle: subtitle,
      unitName: 'Users',
      description: role.description ?? '',
      icon: <i
        className={role.icon} />,
      unitCount: filteredUserList.length,
      buttons: buttons,
      scopeTag: '',
      inScope: false,
      isPartial: false
    });
  });
  cardGroups.push({
    cards
  });
  return cardGroups;
}
